import { render } from "./FancyBoxGallery.vue?vue&type=template&id=1bf1fef1"
import script from "./FancyBoxGallery.vue?vue&type=script&lang=js"
export * from "./FancyBoxGallery.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__